import { render } from "./VideoGenerationView.vue?vue&type=template&id=73d611cc&scoped=true"
import script from "./VideoGenerationView.vue?vue&type=script&lang=js"
export * from "./VideoGenerationView.vue?vue&type=script&lang=js"

import "./VideoGenerationView.vue?vue&type=style&index=0&id=73d611cc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d611cc"]])

export default __exports__